<template>
  <div>
    <data-table :service="ProductService"
                :entity="entity"
                :filters="filters"
                :columns="columns"
                :disablePermissionChecks="true"
                operations="add,edit,refresh,delete"
                ref="table">
      <template slot="name" slot-scope="{row}">
        {{row.name}}
      </template>
      <template slot="product_type" slot-scope="{row}">
        {{row.product_type}}
      </template>
      <template slot="payment_type" slot-scope="{row}">
        {{row.payment_type}}
      </template>
      <template slot="price" slot-scope="{row}">
        {{row.price | toCurrency}}
      </template>

    </data-table>
  </div>
</template>
<script>
  import ProductService from 'src/services/ProductService'
  import { entities } from 'src/config/routeTypes'

  export default {
    name: 'products-settings',
    data () {
      return {
        ProductService,
        entity: entities.PRODUCT
      }
    },
    computed: {
      filters () {
        return [
          {
            key: 'sort',
            value: '+name'
          }
        ]
      },
      columns () {
        return [
          {
            prop: 'name',
            label: this.$t('settings.products.labels.name'),
            minWidth: '200px',
            sortable: true
          }, {
            prop: 'product_type',
            label: this.$t('settings.products.labels.product_type'),
            minWidth: '170px',
            sortable: true
          }, {
            prop: 'payment_type',
            label: this.$t('settings.products.labels.payment_type'),
            minWidth: '170px',
            sortable: true
          }, {
            prop: 'price',
            label: this.$t('settings.products.labels.price'),
            minWidth: '100px',
            sortable: true
          }
        ]
      }
    },
    methods: {
      roleValue (value) {
        let result = value
        let roles = [
          {id: 1, name: 'Admin'},
          {id: 2, name: 'User'},
          {id: 3, name: 'Recruiter'}]
        roles.forEach(role => {
          if (role.uuid === value) {
            result = role.name
          }
        })

        return result
      }
    }
  }
</script>
<style>
</style>
